const t = {
  name: "Podcast",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C9.79086 2 8 3.79086 8 6V10C8 12.2091 9.79086 14 12 14C14.2091 14 16 12.2091 16 10V6C16 3.79086 14.2091 2 12 2ZM10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6V10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10V6Z" fill="currentColor"/>
<path d="M6 10V7H4V10C4 14.0836 7.05068 17.447 11 17.9383V20H7V22H17V20H13V17.9383C16.9493 17.447 20 14.0836 20 10V7H18V10C18 13.3177 15.3177 16 12 16C8.68228 16 6 13.3177 6 10Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Podcast
};
